export default __webpack_public_path__ + "static/ambassador-figure-354100cf25d7a323df25e8b9a43fbfc0.svg";